<template>
	<widget class="list-widget" v-bind="$props" :value="value" @input="input" >
		<div class="header">
			<div class="title">{{ value.settings.label }}</div>
			<div class="subtitle">{{ value.props.subtitle }}</div>
		</div>
		<div class="body">
			<div class="head" :style="{ gridTemplateColumns: _gridTemplateColumns }">
				<div v-for="(c, i) in value.props.columns" :key="i" class="column">{{ c.label }}</div>
			</div>
			<perfect-scrollbar class="body">
				<div class="item" v-for="(item, i) in value.data" :key="i" :style="{ gridTemplateColumns: _gridTemplateColumns }" @contextmenu.prevent="itemContext(item, $event)" @click="itemClick(item, $event)">
					<div class="cell" v-for="(c, j) in value.props.columns" :key="j"><div class="dot" v-if="c.color && item[c.color]" :style="{ backgroundColor: item[c.color] }"></div>{{ item.hasOwnProperty(c.value) ? (c.hasOwnProperty('filter') ? $options.filters[c.filter](item[c.value]) : item[c.value]) : '-' }}</div>
				</div>
			</perfect-scrollbar>
		</div>
	</widget>
</template>

<script>
	import Widget from './Widget'
	import ContextPopupView from '../views/ContextPopupView'
	import TaskController from '../TaskController'
	import QuoteController from '../QuoteController'
	import OrderController from '../OrderController'
	import LeadController from '../LeadController'

	var ctrls = {
		'TaskController': TaskController,
		'QuoteController': QuoteController,
		'OrderController': OrderController,
		'LeadController': LeadController,
	};

	export default {
		components: {
			Widget
		},
		props: {
			value: {
				type: Object
			},
			types: {
				type: Array
			},
			edit: {
				type: Boolean
			}
		},
		computed: {
			_gridTemplateColumns() {
				var r = [];

				if (this.value.props.columns) {
					for (var i = 0; i < this.value.props.columns.length; ++i) {
						r.push(this.value.props.columns[i].weight + 'fr');
					}
				}

				return r.join(' ');
			}
		},
		methods: {
			input(e, value) {
				this.$emit('input', e, value);
			},
			itemClick(item, event) {
				if (this.value.props.ctrl && this.value.props.click) {
					ctrls[this.value.props.ctrl][this.value.props.click](this, item);
				} 
			},
			itemContext(item, event) {
				event.stopPropagation();

				var actions = [];
				var self = this;

				if (this.value.props.ctrl && this.value.props.context) {
					for (var i = 0; i < this.value.props.context.length; ++i) {
						actions.push({
							label: this.value.props.context[i].label,
							action: function () {
								var cont = self.value.props.context[i];

								return function () {
									ctrls[self.value.props.ctrl][cont.action](self, item);
								};
							}()
						});
					}
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event,
					align: 'left',
					actions: actions
				});
			}
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss" scoped>
	.list-widget > .body {
		& > .header {
			& > .title {
				font-size: 18px;
			}

			& > .subtitle {
				margin-top: 5px;
				font-size: 14px;
				height: 18px;
			}

			padding: 20px 20px 10px 20px;
		}

		& > .body {
			min-height: 0;  /* NEW */
			min-width: 0;   /* NEW; needed for Firefox */

			& > .head {
				display: grid;
				border-bottom: 1px solid #cecece;
				
				& > .column {
					font-size: 12px;
					padding: 5px 0 5px 20px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			& > .body {
				/*overflow-y: auto;*/
				position: absolute;
				left: 0;
				top: 104px;
				width: 100%;
				bottom: 0;

				& > .item {
					display: grid;
					cursor: pointer;
					border-top: 1px solid #f0f0f0;

					&:first-child {
						border-top: none;
					}

					& > .cell {
						font-size: 12px;
						padding: 10px 0 10px 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

						& > .dot {
							display: inline-block;
							margin-right: 10px;
							width: 8px;
							height: 8px;
							border-radius: 50%;
						}
					}

					&:hover {
						& > .cell {
							background-color: #F0F0F0;
						}
					}
				}
			}
		}
	}
</style>